import { store } from '../store/store';
import { logout } from '../store/authSlice';

export const logoutUser = () => {
  store.dispatch(logout());
};

export const getAuthToken = () => {
  const state = store.getState();
  return state.auth.token;
};

export const getCurrentUser = () => {
  const state = store.getState();
  return state.auth.user;
};

export const isAuthenticated = () => {
  const state = store.getState();
  return state.auth.isAuthenticated;
};
